'use client'

import { IconDownSmall } from 'icons/components/IconDownSmall'
import { IconEmailL } from 'icons/components/IconEmailL'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { applyStylesIf, cx } from 'utils/cx'

import { useDelayedDays } from '../../../../contexts/DelayedDaysProvider/DelayedDaysProvider'
import type { Size } from '../../../../types/FullProduct'
import { getHasMeta } from '../../utils/getHasMeta'
import { SizeDelayedLabel } from './SizeDelayedLabel/SizeDelayedLabel'

import styles from './SizeItemContent.module.scss'
import text from 'fukku/styles/texts.module.scss'

export interface SizeItemContentProps {
	extraInfoLayout: 'row' | 'column'
	size: Size
	withArrow: boolean
	parsedExtraInfo?: string
	showLastUnits: boolean
	showDelayed: boolean
}

export function SizeItemContent({
	extraInfoLayout,
	size,
	withArrow,
	parsedExtraInfo,
	showLastUnits,
	showDelayed,
}: SizeItemContentProps): React.ReactNode {
	const { t } = useLabels()
	const { delayedTime, hasDelayRange } = useDelayedDays()

	const { available, extraInfo } = size

	const hasMeta = getHasMeta({
		available,
		showLastUnits,
		withArrow,
		showDelayed,
	})

	return (
		<>
			<span
				className={cx(
					styles.sizeInfo,
					applyStylesIf(!available, styles.notAvailable),
					applyStylesIf(extraInfoLayout === 'column', styles.column)
				)}
			>
				<span className={cx(text.bodyMRegular)}>{size.label}</span>
				{extraInfo && (
					<span
						className={cx(
							applyStylesIf(extraInfoLayout === 'column', text.bodyS),
							applyStylesIf(extraInfoLayout !== 'column', text.bodyMRegular)
						)}
					>
						{parsedExtraInfo}
					</span>
				)}
			</span>
			{hasMeta && (
				<span className={cx(styles.meta, text.bodyMRegular)}>
					{!available && (
						<span className={styles.notifyMe}>
							{t('pdp.sizeSelector.notifyMe.link')}
							<IconEmailL />
						</span>
					)}
					{(showLastUnits || showDelayed) && (
						<span className={styles.available}>
							{showLastUnits && (
								<span className={styles.lastUnits}>
									{t('pdp.sizeSelector.lastItems.text')}
								</span>
							)}
							{showDelayed && delayedTime && (
								<SizeDelayedLabel
									delayedTime={delayedTime}
									hasDelayRange={hasDelayRange}
									showLastUnits={showLastUnits}
								/>
							)}
						</span>
					)}
					{withArrow && <IconDownSmall />}
				</span>
			)}
		</>
	)
}
